export enum Language {
  EN = 'en',
  TR = 'tr',
}
